import lpTokens from './lpTokens'

const zapOutTokens = [
  lpTokens.dmd_dai_lp,
  lpTokens.dmd_usdc_lp,
  lpTokens.dmd_wftm_lp,
  lpTokens.dmd_fusdt_lp,
  lpTokens.dmd_dola_lp,
  lpTokens.dmd_weth_lp,
  lpTokens.dmd_wbtc_lp,
  lpTokens.dmd_mim_lp,
  lpTokens.ftm_boo_lp,
  lpTokens.ftm_wbtc_lp,
  lpTokens.ftm_weth_lp,
  lpTokens.usdc_ftm_lp,
  lpTokens.dai_ftm_lp,
  lpTokens.ftm_mim_lp,
  lpTokens.ftm_bnb_lp,
  lpTokens.usdc_dai_lp,
  lpTokens.usdc_fusdt_lp,
  lpTokens.wbtc_weth_lp,
  lpTokens.crv_ftm_lp,
  lpTokens.sushi_ftm_lp,
  lpTokens.r4id_usdc_lp,
  lpTokens.ape_wftm_lp,
  lpTokens.ust_ftm_lp,
  lpTokens.luna_ftm_lp,
  lpTokens.ring_usdc_lp,
]

export default zapOutTokens
